import { Button } from "../Helpers";
import style from "./actionSection.scss";

const ActionSection = ({ onClickAction, searchText }) => {
  return (
    <div className={style.actionSection}>
      <p className={style.actionTitle}>
        Didn't find what you were looking for?
      </p>
      <div className={style.buttonGroup}>
        <Button
          onClick={() => onClickAction("ShowAdditionalButtons", { title: searchText })}
          className={style.actionButton}
        >
          Submit Ticket
        </Button>
        <Button
          type="secondary"
          onClick={() =>
            onClickAction("AccessibilityIssueV2", { title: searchText })
          }
          className={style.actionButton}
        >
          Submit Accessibility Issue
        </Button>
      </div>
    </div>
  );
};

export default ActionSection;



// WEBPACK FOOTER //
// ./components/SearchHelpCenter/ActionSection.js